import { stats } from '@/mocks/home';

export default function StatsBar() {
  return (
    <section className="relative -mt-10 z-20">
      <div className="w-full max-w-[1024px] mx-auto px-4 md:px-6">
        <div className="bg-background-50 rounded-2xl border border-background-200/70 py-8 px-6 md:px-10 grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 animate-fade-in-up">
          {stats.map((stat, idx) => (
            <div key={stat.id} className="text-center">
              <div className="text-2xl md:text-3xl font-bold font-heading text-primary-500 mb-1">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-foreground-500">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}